module.exports = "/_next/static/images/ca66f7440ec6192ecee178097630a74e-moneyboxes-right-desktop.jpg";